const yhbRoute = '/service/sailing-version';
const jrzyRoute = '/service/financial-terminal';
const macRoute = '/service/mac-version';
export const CATALOG_LIST = [{
  catalog: '手机OEM',
  productList: [{
    name: '移动金融终端',
    desc: '同花顺手机OEM拥有完整的产业链体系，包含行情、交易、商城、投顾、中台、指标运营、数据分析、AI智能、i问财等，是一款集行情、交易、资讯等一站式终端投资理财平台。',
    url: '/service/phone-oem'
  }]
}, {
  catalog: 'PC',
  productList: [{
    name: '远航版',
    desc: '远航版主打年轻人群及新生代股民，拥有扁平化、全新高DPI界面、运行更快、更节省内存等优势，用户体验更好。',
    url: yhbRoute
  }, {
    name: '金融终端2.0',
    desc: '金融终端2.0集行情、交易、投资、理财、资讯为一体的综合投资理财网上交易终端，主打经典交互及资深股民，其交易、工具、数据一站式整合的布局更符合多数老股民的使用习惯。',
    url: jrzyRoute
  }, {
    name: 'Mac版',
    desc: '完美适配Mac原生系统，拥有快捷手势交互操作，配合自定义“独立弹窗”，大幅提高Mac端看盘效率。',
    url: macRoute
  }, {
    name: '机构交易版',
    desc: '同花顺机构交易版依托大数据、AI技术为专业投资者提供如篮子交易、策略交易、算法交易等丰富的个性化交易功能， 有效解决委托延时高、交易成功率低两大核心交易问题，为投资者带来极致的速度体验。',
    url: '/service/institutional-trading'
  }]
}, {
  catalog: '大数据',
  productList: [{
    name: '大数据',
    desc: '同花顺大数据产品是基于AARRR 用户生命周期管理模型，为互联网经营者提供数据分析及精细运营支持的工具，它集账户分析、账户诊断、行为分析、标签系统、智能推荐、标签云等功能于一体，助力企业经营更科学、更智能。',
    url: '/service/big-data'
  }, {
    name: '资讯',
    desc: '同花顺致力为行业提供专业的资讯服务，利用丰富的内容资源、可靠的内容技术能力，解决内容来源、加工审核、分发策略等问题，帮助客户搭建一整套的资讯运营体系',
    url: '/service/Information'
  }, {
    name: '智能投研',
    desc: '同花顺智能投研系统在金融大数据的支持下，通过机器学习、深度学习、NLP等AI技术，对数据、资讯事件、观点逻辑等信息进行自动化处理和分析，高效处理全网信息，智能辅助成果生产，提高分析师、基金经理等从业人员的投工作效率和投研能力。',
    url: '/service/investment-research'
  }]
}, {
  catalog: 'OPENAI',
  productList: [{
    name: 'OPENAI',
    desc: '同花顺OpenAI开放平台向泛金融合作伙伴提供行业领先的语音、图像、NLP等人工智能技术及海量的金融数据，共享金融科技领域最新的应用场景和解决方案，帮助客户快速搭建金融产品及业务系统。',
    url: '/service/openAI'
  }]
}, {
  catalog: 'AI产品',
  productList: [{
    name: '客服机器人',
    desc: '客服机器人可通过与线上用户的问答记录，对线上问句自动分类，聚类发现新知识，并根据业务流程，引导用户理清复杂问题，辅助运营人员智能高效解决客户问题。',
    url: '/service/CustomerServiceBot'
  }, {
    name: '智能外呼',
    desc: '智能外呼适用于各类电销、回访、催收、通知等外呼场景，可以对大量、简单、重复耗时的呼叫和记录工作进行自动化处理，快速高效完成外呼任务，帮助企业降本增效。',
    url: '/service/OutboundCallingBot'
  }, {
    name: '智能质检',
    desc: '智能质检系统利用机器质检替代人工质检的同时还对客服录音进行全面检测，并自动化生成质检报表和质检报告，质检报表和质检报告支持多维度自定义条件选择，可大幅提升工作效率，降低抽检不完备带来的隐患。',
    url: '/service/CallQualityInspection'
  }, {
    name: '智能客服',
    desc: '智能客服可以解决了人工成本高昂、服务效率低下、易受情绪影响等问题，24小时实时在线，让用户在同电话智能客服愉快轻松的交流中解决问题。',
    url: '/service/OnlineSupport'
  }, {
    name: '虚拟人',
    desc: '同花顺AI虚拟人运用多模态数字人对话技术，实现与真人用户“面对面”的交互体验。主要面向券商、银行、运营商、政务、媒体等行业，旨在为客户提供智能化数字人解决方案，提升用户体验、提高服务效率、降低企业人力成本，给客户带来更高的价值。',
    url: '/service/Vtuber'
  }, {
    name: '智能投资助理',
    desc: '智能投资助理是一种基于自然语言理解的智能交互系统，它能够精确理解用户的意图或提问，并根据丰富的垂类内容和海量知识图谱，给予用户满意的回答，其最大的特征就是门槛低、效率高，可以让大众客户同样获得专业化、个性化高效化的金融投顾服务。',
    url: '/service/IntelligentInvestmentAssistant'
  }, {
    name: '短视频平台',
    desc: '同花顺AI短视频平台作为智能化的短视频生产工具，其内容框架由金融专家预设，经过超长时间和庞大金融语料的训练，最终利用数据可视化及虚拟人播报等技术，实现了短视频的自动化生产。该平台的出现，打破了短视频制作的技术壁垒，让零基础的内容生产者像做PPT一样，通过简单的拖拽和拼装，即可批量产出视频内容，并在云端实现视频的自动化生产与推送。',
    url: '/service/ShortsPlatform'
  }]
}, {
  catalog: '投资顾问',
  productList: [{
    name: '人工投顾',
    desc: '互联网投顾平台功能包括直播、观点、问股、服务包、组合等，它引入智能选股、诊股以及机器人助手等智能工具，帮助投顾快速提升服务效率和质量，运用互联网的方式吸引粉丝关注并转化创收。',
    url: '/service/investment-advisor'
  }]
}, {
  catalog: '运营工具',
  productList: [{
    name: '活动运营平台',
    desc: '运营平台是一款适用于证券等行业的活动营销工具，它整合了同花顺多年的运营经验及技术能力赋能行业实现自动化营销，高效便捷地助力APP运营者实现快速拉新、留存、促活，不断提升用户转化率',
    url: '/service/operating-activities'
  }, {
    name: '自选股同步',
    desc: '同花顺手机OEM拥有完整的产业链体系，包含行情、交易、商城、投顾、中台、指标运营、数据分析、AI智能、i问财等，是一款集行情、交易、资讯等一站式终端投资理财平台。',
    url: '/service/self-select-stock'
  }]
}];
export const SKILL_LIST = [{
  title: '同花顺强大底层架构',
  desc: '承载80+中大型券商/银行运维实践，久经考验值得信赖。',
  img: 'power.png'
}, {
  title: '8年中台构建经验',
  desc: '不断迭代，打造金融中台服务、营销生态。',
  img: 'build.png'
}, {
  title: '国内一流的算法专家团队',
  desc: '深厚的自然语言处理和推荐算法积累，依托大数据平台，为行业智能营销与推荐赋能。',
  img: 'first.png'
}, {
  title: '通过ISO9001、CMMI3认证',
  desc: '品质交付，值得信赖。',
  img: 'ISO.png'
}];
export const RECOMMEND_LIST = [{
  img: 'home-pazq.png',
  leader: '平安证券：副总裁郑霞',
  content: '在金融供给侧改革、金融业加速开放的背景下，专业能力越来越成为金融机构的立身之本。同花顺以金融科技为抓手，围绕行情交易、人工智能、资讯服务等场景向我们提供了品类齐全、品质精良的金融AI产品和“伴随式”服务能力，更好的助力平安证券达成“打造智能化证券服务平台”这一美好愿景。',
  relativeProducts: [{
    name: '金融终端',
    link: jrzyRoute
  }, {
    name: '自选股同步',
    link: '/service/self-select-stock'
  }, {
    name: '智能投研',
    link: '/service/investment-research'
  }, {
    name: '智能客服',
    link: '/'
  }, {
    name: '资讯产品',
    link: '/'
  }, {
    name: '智能选股',
    link: '/'
  }, {
    name: '智能诊股',
    link: '/'
  }]
}, {
  img: 'home-zszq.png',
  leader: '浙商证券：信息技术事业部总经理黄玉锋',
  content: '证券是一个与数字打交道的行业，而同花顺以数据为基础的行为分析、智能资讯、理财投顾等产品正是我们的刚需。它们能够融合大数据及金融AI技术，助力浙商证券达成“千人千面”的个性化运营效果，大幅提升客户的活跃度、留存率和转化率，其私有化的部署方案也免除了我们的后顾之忧。未来，浙商证券将继续秉承“同创、同享、同成长”的理念，与同花顺一道为广大客户提供更加专业化、智能化、个性化的投资理财服务。',
  relativeProducts: [{
    name: '远航版',
    link: yhbRoute
  }, {
    name: 'MAC版',
    link: macRoute
  }, {
    name: '账户分析',
    link: '/'
  }, {
    name: '资讯推荐',
    link: '/'
  }, {
    name: '理财商城',
    link: '/'
  }, {
    name: '活动运营中台',
    link: '/service/operating-activities'
  }]
}, {
  img: 'home-zgyh.png',
  leader: '银河证券：信息技术部副总经理魏自恩',
  content: '“银河证券双子星”是我们在躬身落实“银河实践”路上交出的答卷之一。它整合同花顺问财服务、iFinD数据等金融科技能力，打造了集行情、交易、运营功能于一体的金融终端，一站式满足了客户从行情交易、信息获取到资产配置的多层次需要。未来，银河证券还将联合同花顺持续优化金融科技应用功能及场景，为客户打造更专业、更全面、更智能的金融投资交易平台。',
  relativeProducts: [{
    name: '金融终端',
    link: jrzyRoute
  }, {
    name: '远航版',
    link: yhbRoute
  }, {
    name: 'Mac版',
    link: macRoute
  }, {
    name: 'MindGo',
    link: '/'
  }]
}, {
  img: 'home-dfzq.png',
  leader: '东方证券：互金副总经理袁冰青',
  content: '东方证券联合同花顺打造的“东方天玑”立足客户服务，关注用户体验，借助AI技术，将专业能力工具化，为客户提供的覆盖投前、投中、投后全生命周期的在线投资增值服务生态。它还将我们从常规的、繁杂的运营工作中解放出来，助力我们更好地去提升服务品质、运营效率以及数据应用能力，显著提高团队整体价值。未来，我们还将继续于同花顺携手，将“东方天玑”打造成行业标杆和知名互联网品牌。',
  relativeProducts: [{
    name: '智能投资助理',
    link: '/'
  }, {
    name: 'MAC版',
    link: macRoute
  }]
}];